import HeaderForForm from '@/components/HeaderForForm';
import ContentForm from '@/components/ContentForm';
import { _prepareErrors } from '@/utils/_function.js';
import moment from 'moment';
import * as Api from '@/api';

export default {
  name: 'AddContent',
  data() {
    return {
      formContent: {},
      defaultValueForm: {},
      isAddLink: [],
      contentId: null,
      isDataSaving: false,
      isDisabled: false,
      isLoadData: false,
      currentProprietorList: null
    };
  },
  components: {
    HeaderForForm,
    ContentForm
  },
  created() {
    this.contentId = this.$route.params.id;

    if (this.contentId) {
      Api.getContentDetailData(this.contentId)
        .then((response) => {
          this.formContent = response.data.attributes;
          this.formContent.proprietorId = response.data.relationships.proprietor.data.id;
          this.formContent.releaseYearOn = response.data.attributes.releaseYearOn;
          this.isLoadData = true;
          if (this.formContent.legalLinks) {
            let number = this.formContent.legalLinks.length;

            while (number > 0) {
              this.isAddLink.push({
                fl: true,
                error: false
              });

              number--;
            }
          } else {
            this.isAddLink = [];
          }
          this.defaultValueForm = {
            ...this.formContent,
            legalLinks: [...this.formContent.legalLinks] };

          const currentProprietor = response.included.find((item) => (
            item.type === 'proprietors'
          ));
          const list = [];
          list.push({
            id: currentProprietor.id.toString(),
            name: currentProprietor.attributes.name
          });
          this.currentProprietorList = list;
        })
        .catch((error) => {
          if (error) {
            this.$rollbar.warning(error);
          }
          this.$toastr('error', this.$t('commonMessage.requestError'), 'Ошибка');
        });
      this.formContent.priority = this.formContent.priority;
    } else {
      this.isLoadData = true;
    }
  },
  methods: {
    updatingData(value) {
      const { formContent } = value;
      const data = {
        formContent
      };

      this.isDataSaving = false;
      Object.assign(this.$data, data);
    },
    closeForm() {
      this.$router.push({ path: `/content/${this.contentId}` });
    },
    performFormAction() {
      this.isDataSaving = true;
    },
    savingData() {
      if (this.formContent.legalLinks.length) {
        let index = this.formContent.legalLinks.length - 1;

        if (!this.formContent.legalLinks[index].url) {
          this.formContent.legalLinks.splice(index, 1);
          this.isAddLink.splice(index, 1);
        }

        if (this.isAddLink[index] && this.isAddLink[index].fl === false) {
          this.formContent.legalLinks.splice(index, 1);
          this.isAddLink.splice(index, 1);
        }
      }

      this.formContent.releaseYearOn = moment(this.formContent.releaseYearOn).format();
      this.isDisabled = true;
      this.isDataSaving = false;

      if (this.contentId) {
        Api.editContent(this.contentId, { data: this.formContent })
          .then((response) => {
            if (response) {
              this.$toastr('success', this.$t('formContent.successEditContent'));
              this.$router.push({ path: `/content/${this.contentId}` });
              this.isDisabled = false;
            }
          })
          .catch((errors) => {
            if (errors) {
              _prepareErrors(errors).forEach((err) => {
                this.$toastr('error', err, 'Ошибка');
              });

              this.$rollbar.warning(errors);
              this.$toastr('error', this.$t('formContent.errorEditContent'), 'Ошибка');
            }
            this.isDisabled = false;
          });
      }
    }
  }
};
